import { URL_API } from 'constants/api.constant'
import ApiService from './ApiService'

export async function apiMisTours() {
    return ApiService.fetchData({
        url: `${URL_API}/usuarios/mis-tours`,
        method: 'get',
    })
}

export async function apiCompletarTour(tour) {
    return ApiService.fetchData({
        url: `${URL_API}/usuarios/mis-tours`,
        method: 'put',
        data: { tour },
    })
}
